import { render, staticRenderFns } from "./userOption.vue?vue&type=template&id=34116764&"
import script from "./userOption.vue?vue&type=script&lang=js&"
export * from "./userOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34116764')) {
      api.createRecord('34116764', component.options)
    } else {
      api.reload('34116764', component.options)
    }
    module.hot.accept("./userOption.vue?vue&type=template&id=34116764&", function () {
      api.rerender('34116764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/users/userOption.vue"
export default component.exports